import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'src/app/store';
import axios from 'src/utils/axios';

type invoiceDataState = {
  cancelInvoiceData: any;
  cancelInvoiceLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
};

const initialState = {
  cancelInvoiceData: {},
  cancelInvoiceLoading: 'loading',
} as invoiceDataState;

export const cancelInvoice = createAsyncThunk('Invocie/Cancel', async (ids: number[]) => {
  const response = await axios.post(`/Invoice/Cancel`, ids);
  return response.data;
});

export const invoiceSlice = createSlice({
  name: 'Invoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(cancelInvoice.fulfilled, (state, action: PayloadAction<any>) => {
        state.cancelInvoiceData = action.payload;
        state.cancelInvoiceLoading = 'succeeded';
      })
      .addCase(cancelInvoice.rejected, (state) => {
        state.cancelInvoiceLoading = 'failed';
      })
      .addCase(cancelInvoice.pending, (state) => {
        state.cancelInvoiceLoading = 'pending';
      });
  },
});

export const selectInvoiceUse = (state: RootState) => state.invoice;
export default invoiceSlice.reducer;
